import {Log} from '@aboutyou/mlm';
import React, {useEffect} from 'react';

export const BrowserMemoryConsumptionTracker: React.FC = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const memoryUsage = getBrowserMemorySnapshot();
      if (!memoryUsage) {
        return;
      }

      Log.info('@aboutyou/bootstrap', 'MemoryConsumption', {
        minuteMark: 1,
        memory: memoryUsage,
      });
    }, 60000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  // when the Window is closed, log the total memory consumption
  useEffect(() => {
    const logTotalMemoryConsumption = () => {
      const memoryUsage = getBrowserMemorySnapshot();
      if (!memoryUsage) {
        return;
      }

      Log.info('@aboutyou/bootstrap', 'TotalMemoryConsumption', memoryUsage);
    };
    window.addEventListener('beforeunload', logTotalMemoryConsumption);

    return () => {
      window.removeEventListener('beforeunload', logTotalMemoryConsumption);
    };
  }, []);

  return null;
};

const getBrowserMemorySnapshot = () => {
  const memory = (performance as any)?.memory
    ? (
        performance as unknown as {
          memory?: {
            totalJSHeapSize: number;
            usedJSHeapSize: number;
            jsHeapSizeLimit: number;
          };
        }
      ).memory
    : null;

  if (!memory) {
    return null;
  }

  return {
    usedJSHeapSize: memory?.usedJSHeapSize,
    totalJSHeapSize: memory?.totalJSHeapSize,
    jsHeapSizeLimit: memory?.jsHeapSizeLimit,
  };
};
